import React from "react";

import { act, fireEvent, render, screen } from "@testing-library/react";
import { RiMedal2Fill } from "react-icons/ri";

import SecaoDeConquista from "./SecaoDeConquista";

function montar(props = {}) {
  return render(
    <SecaoDeConquista
      id="medalhas"
      titulo="Minhas medalhas"
      descricao="Pela sua constância"
      Icone={RiMedal2Fill}
      aberta
      onAlternar={() => {}}
      {...props}
    >
      <p>conteúdo da seção</p>
    </SecaoDeConquista>
  );
}

describe("SecaoDeConquista", () => {
  it("dá a MESMA moldura a qualquer tipo: título, descrição e conteúdo", () => {
    // É o que faz "futuros tipos de conquista" caberem sem redesenho — enquanto cada
    // tipo desenhava o próprio cabeçalho, a página tinha um dialeto por seção.
    montar();

    expect(
      screen.getByRole("button", { name: /Minhas medalhas/ })
    ).toBeInTheDocument();
    expect(screen.getByText("Pela sua constância")).toBeInTheDocument();
    expect(screen.getByText("conteúdo da seção")).toBeInTheDocument();
  });

  it("mostra o contador que o CONTEÚDO reportou", () => {
    // O painel não conta nada: quem sabe contar medalha é a seção de medalhas, e quem
    // sabe contar carta é a coleção. O painel só sabe que todo tipo tem um "de".
    montar({ resumo: { conquistadas: 3, total: 12 } });

    const botao = screen.getByRole("button", { name: /Minhas medalhas/ });
    expect(botao).toHaveTextContent("3");
    expect(botao).toHaveTextContent("12");
  });

  it("NÃO mostra contador antes de o dado chegar", () => {
    // Sem resumo, uma pílula "0 / 0" diria "não há nada a conquistar", que é o oposto
    // do que a tela quer dizer.
    const { container } = montar({ resumo: null });
    expect(container.querySelector(".conquistas__secao-contador")).toBeNull();

    // E também não com total zero, que é o mesmo caso vindo de um endpoint vazio.
    montar({ resumo: { conquistadas: 0, total: 0 } });
    expect(
      document.querySelectorAll(".conquistas__secao-contador")
    ).toHaveLength(0);
  });

  it("recolher DESMONTA o conteúdo — depois da animação, não no clique", () => {
    // Desmontar e não esconder: a coleção tem até 110 imagens, e a seção recolhida não
    // deve pagar por elas.
    //
    // O DESMONTE ESPERA A ANIMAÇÃO desde 20/08/2026. O recolhimento passou a percorrer
    // a altura, e o que sai da árvore não anima — então o conteúdo fica montado
    // enquanto a altura fecha. A decisão de desmontar não mudou; o momento mudou.
    jest.useFakeTimers();
    const onAlternar = jest.fn();
    const { rerender } = montar({ onAlternar });

    const botao = screen.getByRole("button", { name: /Minhas medalhas/ });
    expect(botao).toHaveAttribute("aria-expanded", "true");

    fireEvent.click(botao);
    expect(onAlternar).toHaveBeenCalledTimes(1);

    // O estado é do pai, então o clique não recolhe sozinho — é o `aberta` que muda.
    rerender(
      <SecaoDeConquista
        id="medalhas"
        titulo="Minhas medalhas"
        Icone={RiMedal2Fill}
        aberta={false}
        onAlternar={onAlternar}
      >
        <p>conteúdo da seção</p>
      </SecaoDeConquista>
    );

    expect(
      screen.getByRole("button", { name: /Minhas medalhas/ })
    ).toHaveAttribute("aria-expanded", "false");

    // Ainda na árvore: é o que a animação precisa para ter o que encolher.
    expect(screen.queryByText("conteúdo da seção")).toBeInTheDocument();

    act(() => {
      jest.advanceTimersByTime(600);
    });

    // E agora sai, que é a decisão original.
    expect(screen.queryByText("conteúdo da seção")).not.toBeInTheDocument();
    jest.useRealTimers();
  });

  it("o alvo de `aria-controls` existe TAMBÉM recolhido", () => {
    // Um alvo que só existe quando aberto deixa a referência quebrada justamente no
    // estado em que o leitor de tela precisa dela.
    montar({ aberta: false });

    const botao = screen.getByRole("button", { name: /Minhas medalhas/ });
    const alvo = botao.getAttribute("aria-controls");
    expect(document.getElementById(alvo)).not.toBeNull();
  });

  /* A ANIMAÇÃO DO RECOLHIMENTO nas seções da página. O que se protege aqui é o que
     quebra em silêncio — jsdom não anima, então nada disto mede movimento:

     que o conteúdo espere a altura fechar antes de sair da árvore (o teste acima), e
     que o estado final não deixe a seção com altura natural sem conteúdo, que é a
     piscada consertada no mesmo dia na grade das regiões. */
  describe("a animação do recolhimento", () => {
    function conteudoDaSecao() {
      return document.getElementById("conquistas-medalhas-conteudo");
    }

    function recolher(onAlternar = () => {}) {
      const { rerender } = montar({ onAlternar });
      rerender(
        <SecaoDeConquista
          id="medalhas"
          titulo="Minhas medalhas"
          Icone={RiMedal2Fill}
          aberta={false}
          onAlternar={onAlternar}
        >
          <p>conteúdo da seção</p>
        </SecaoDeConquista>
      );
    }

    beforeEach(() => jest.useFakeTimers());
    afterEach(() => jest.useRealTimers());

    it("a seção fechada FICA com altura zero, e não volta à altura natural", () => {
      // Se a altura voltasse a `auto` antes de o conteúdo desmontar, a seção
      // reapareceria inteira por um quadro. Foi o defeito medido na grade das regiões
      // (`ferramentas-diagnostico/diagnosticar-piscada-collapse.js`), e a mecânica é a
      // mesma aqui.
      recolher();
      act(() => {
        jest.advanceTimersByTime(600);
      });

      expect(conteudoDaSecao().style.height).toBe("0px");
      expect(conteudoDaSecao().style.overflow).toBe("");
      expect(conteudoDaSecao().style.transition).toBe("");
    });

    it("recolher NÃO desmonta e remonta o conteúdo no caminho", () => {
      /* O conteúdo tem de ficar montado do clique até o fim da animação — uma vez, sem
         piscar fora da árvore e voltar.
 
         POR QUE ISSO IMPORTA E NÃO É ZELO: quem monta aqui é `ColecaoDeCartasDoAluno`,
         que busca a coleção do servidor num `useEffect`. Desmontar e remontar dispara
         a requisição DE NOVO — recolher a seção passaria a custar uma ida ao backend,
         e o sintoma (uma chamada a mais em `activity/ludic-trail/collection`) só
         apareceria olhando a aba de rede.
 
         É o que a derivação de `fechando` durante o render evita: sem ela, o render do
         clique já devolve `oculto: true`, o React desmonta, e só então o efeito
         remonta. Em jsdom o ciclo TERMINA no mesmo lugar — daí este teste contar
         montagens em vez de olhar o DOM no fim. */
      let montagens = 0;
      function Espia() {
        React.useEffect(() => {
          montagens += 1;
        }, []);
        return <p>conteúdo da seção</p>;
      }

      const onAlternar = () => {};
      const props = {
        id: "medalhas",
        titulo: "Minhas medalhas",
        Icone: RiMedal2Fill,
        onAlternar
      };
      const { rerender } = render(
        <SecaoDeConquista {...props} aberta>
          <Espia />
        </SecaoDeConquista>
      );
      expect(montagens).toBe(1);

      rerender(
        <SecaoDeConquista {...props} aberta={false}>
          <Espia />
        </SecaoDeConquista>
      );
      act(() => {
        jest.advanceTimersByTime(600);
      });

      // Uma montagem, e só: o conteúdo nunca saiu para voltar.
      expect(montagens).toBe(1);
      expect(screen.queryByText("conteúdo da seção")).not.toBeInTheDocument();
    });

    it("reabrir devolve o conteúdo e limpa a altura", () => {
      const onAlternar = () => {};
      const { rerender } = montar({ onAlternar });

      const fechada = (
        <SecaoDeConquista
          id="medalhas"
          titulo="Minhas medalhas"
          Icone={RiMedal2Fill}
          aberta={false}
          onAlternar={onAlternar}
        >
          <p>conteúdo da seção</p>
        </SecaoDeConquista>
      );
      rerender(fechada);
      act(() => {
        jest.advanceTimersByTime(600);
      });
      expect(screen.queryByText("conteúdo da seção")).not.toBeInTheDocument();

      rerender(
        <SecaoDeConquista
          id="medalhas"
          titulo="Minhas medalhas"
          Icone={RiMedal2Fill}
          aberta
          onAlternar={onAlternar}
        >
          <p>conteúdo da seção</p>
        </SecaoDeConquista>
      );
      act(() => {
        jest.advanceTimersByTime(600);
      });

      expect(screen.getByText("conteúdo da seção")).toBeInTheDocument();
      // Sem `0px` sobrando de quando estava fechada — senão a seção abriria vazia.
      expect(conteudoDaSecao().style.height).toBe("");
    });
  });
});
